import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';

type Props = {
  color?: string;
};

const LargeCircleCheckIcon = ({
  color = colors.madison,
}: Props): JSX.Element => (
  <VectorIcon width={24} height={24}>
    <circle cx="12" cy="12" r="12" fill={color} />
    <path
      d="M17.8033 9.76418C18.1971 9.36069 18.1971 8.70631 17.8033 
    8.30262C17.4096 7.89913 16.7712 7.89913 16.3774 8.30262L10.3266 14.5051L7.81967 
    11.9354C7.42604 11.5317 6.78764 11.5317 6.39401 11.9354C6.00018 12.3389 6.00018 
    12.9933 6.39401 13.3968L9.61376 16.6974C10.0076 17.1009 10.6458 17.1009 11.0396 
    16.6974L17.8033 9.76418Z"
      fill={colors.white}
    />
  </VectorIcon>
);

export default LargeCircleCheckIcon;
